<template>
  <a v-if="!$vlastMode && $userIsClient" :href="helpLink" target="_blank" class="helpButton" @click="trackHelpClick">
    <i class="fa fa-life-buoy"></i> Help
  </a>
</template>

<script>
import {mapState} from 'vuex'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [OpportunityTracker],

  methods: {
    trackHelpClick () {
      this.trackEvent(this.analytics.V2.HelpIconClickEvent, { pageName: this.$route.name })
    }
  },

  computed: {
    ...mapState('app', ['helpLink'])
  }
}
</script>

<style lang="scss" scoped >

@import "src/assets/sass/colours";

.helpButton {
  display: inline-block;
  color: var(--brand-primary);
  background-color: white;
  padding: 0.5rem 1.5rem 0.5rem 1.25rem;
  border: solid 2px var(--brand-primary);
  font-size: 1.1em;
  font-weight: bold;
  border-radius: 999em;

  i {
    font-size: 1rem;
    margin-right: 0.3rem;
  }

  &:hover {
    background-color: var(--brand-primary);
    color: white;
  }
}

</style>
